import React, {
    useCallback,
    useMemo
} from 'react';
import { CustomSelect } from 'apps/sigma2-ui/src/components/ui/CustomSelect';
import { TableViewFilterProps } from 'libs/end-to-end/src/custom-viz/TableViewTypes';

export const FilterBreakdownSelector = (
    props: TableViewFilterProps,
  ) => {
    const { data, setViewConfiguration, viewConfiguration } = props;
  
    const filterBreakdownChangeCb = useCallback(
      (filterBreakdown: string) => {
        if (setViewConfiguration) {
          setViewConfiguration({
            ...viewConfiguration,
            selectedFilterDefinition: filterBreakdown,
          });
        }
      },
      [setViewConfiguration, viewConfiguration],
    );

    const options = useMemo(() => {
      return data.filtersToBreakdown ?? [];
    }, [data.filtersToBreakdown]);

    if (options.length === 0) {
      return null;
    }
  
    return (
      <div className="flex items-center gap-2 ">
        <CustomSelect
          selectedValue={
            viewConfiguration?.selectedFilterDefinition ?? options[0].value
          }
          options={options}
          onChange={filterBreakdownChangeCb}
        />
      </div>
    );
  };
